var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('color-picker',{on:{"change":_vm.inputColor},model:{value:(_vm.handler),callback:function ($$v) {_vm.handler=$$v},expression:"handler"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }